import { IconChef, IconLightbulb } from "@tine/designsystem-icons/sharp";
import { Card } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { trim } from "lodash-es";
import TrackedAlert from "../../TrackedAlert";

type StepTipProps = {
   tip?: string | null;
   variant: "tip" | "information";
   title?: string;
   lightbulbIcon?: boolean;
   className?: string;
};

const StepTip = ({ tip, variant, title, lightbulbIcon, className }: StepTipProps) => {
   if (tip) {
      if (tip.includes("data-unresolved-url")) {
         return null;
      }

      const styles = cn("mt-2", className);

      const cleanedTip = tip.replace(/(<([^>]+)>)/gi, "").replace("&nbsp;", " ");
      if (trim(cleanedTip).length === 0) {
         // If there is no content left after removing html tags, don't who alert container
         return null;
      }

      if (variant === "tip") {
         return (
            <Card
               className={cn("p-4 max-w-none mt-2 bg-surface-tip text-ink-brand-default", "flex gap-x-2", className)}
               borderVariant="none"
            >
               <IconChef width={28} height={24} className="w-fit" />
               <div className="flex flex-col w-full gap-y-2">
                  <p className="font-semibold text-regular leading-normal @sm:text-lg mb-0">{title}</p>
                  <div className="text-base leading-normal">{cleanedTip}</div>
               </div>
            </Card>
         );
      }

      return (
         <TrackedAlert
            variant={variant}
            title={title}
            fullWidth
            showCloseButton={false}
            className={styles}
            customIcon={lightbulbIcon ? IconLightbulb : undefined}
            source="StepTip"
            tracking={{
               context: "recipe",
               text: "cms_step_tip"
            }}
         >
            {cleanedTip}
         </TrackedAlert>
      );
   }
   return null;
};

export default StepTip;
